// Colors used from Figma file: Maximor Design System

// Colors / Base / Primary Green
const basePrimaryGreen = {
  primaryGreen1: '#e8edeb',
  primaryGreen2: '#b6c6c1',
  primaryGreen3: '#62847a',
  primaryGreen4: '#446c60',
  primaryGreen5: '#154738',
  primaryGreen6: '#134133',
  primaryGreen7: '#0f3228',
  primaryGreen8: '#0c271f',
  primaryGreen9: '#091e18',
} as const;

// Colors / Base / Lime
const baseLime = {
  lime1: '#fbfcec',
  lime2: '#f4f7c4',
  lime3: '#e7ed80',
  lime4: '#e2e968',
  lime5: '#dbe442',
  lime6: '#c7cf3c',
  lime7: '#9ba22f',
  lime8: '#787d24',
  lime9: '#5c601c',
  lime10: '#494d0e',
} as const;

// Colors / Base / Smart Grey
const baseSmartGrey = {
  smartGrey1: '#f3f3f4',
  smartGrey2: '#dadbde',
  smartGrey3: '#c8cace',
  smartGrey4: '#a0a2aa',
  smartGrey5: '#888b95',
  smartGrey6: '#7c7e88',
  smartGrey7: '#61636a',
  smartGrey8: '#4b4c52',
  smartGrey9: '#393a3f',
} as const;

// Colors / Base / Paper White
const basePaperWhite = {
  paperWhite1: '#fdfdfd',
  paperWhite2: '#f9f9f9',
  paperWhite3: '#f6f6f6',
  paperWhite4: '#efefef',
  paperWhite5: '#ebebeb',
  paperWhite6: '#d6d6d6',
  paperWhite7: '#a7a7a7',
  paperWhite8: '#818181',
  paperWhite9: '#636363',
} as const;

// Colors / Base / Ledger White
const baseLedgerWhite = {
  ledgerWhite1: '#fcfcfe',
  ledgerWhite2: '#f7f6fc',
  ledgerWhite3: '#f3f1fb',
  ledgerWhite4: '#eae7f8',
  ledgerWhite5: '#e5e1f6',
  ledgerWhite6: '#d0cde0',
  ledgerWhite7: '#a3a0af',
  ledgerWhite8: '#7e7c87',
  ledgerWhite9: '#605f67',
} as const;

// Colors / Base / Subtle Mint
const baseSubtleMint = {
  subtleMint1: '#f9fef9',
  subtleMint2: '#edfdec',
  subtleMint3: '#e4fce3',
  subtleMint4: '#d0f9ce',
  subtleMint5: '#c4f8c2',
  subtleMint6: '#b2e2b1',
  subtleMint7: '#8bb08a',
  subtleMint8: '#6c886b',
  subtleMint9: '#526851',
} as const;

// Colors / Base / Mauve Grey
const baseMauveGrey = {
  mauveGrey1: '#f7f5f7',
  mauveGrey2: '#f0edf0',
  mauveGrey3: '#e9e4e9',
  mauveGrey4: '#d9d0d9',
  mauveGrey5: '#d0c4d0',
  mauveGrey6: '#bdb2bd',
  mauveGrey7: '#948b94',
  mauveGrey8: '#726c72',
  mauveGrey9: '#575257',
} as const;

// Colors / Base / Cyan
const baseCyan = {
  cyan1: '#eefafc',
  cyan2: '#c9eef6',
  cyan3: '#afe6f1',
  cyan4: '#73d3e7',
  cyan5: '#50c8e1',
  cyan6: '#49b6cd',
  cyan7: '#398ea0',
  cyan8: '#2c6e7c',
  cyan9: '#22545f',
} as const;

// Colors / Base / Green
const baseGreen = {
  green1: '#e6f2ee',
  green2: '#b2d7ca',
  green3: '#8cc4b0',
  green4: '#389976',
  green5: '#067f54',
  green6: '#05744c',
  green7: '#045a3c',
  green8: '#03462e',
  green9: '#033523',
} as const;

// Colors / Base / Red
const baseRed = {
  red1: '#feeced',
  red2: '#fac3c6',
  red3: '#f8a5aa',
  red4: '#f3636b',
  red5: '#f03c46',
  red6: '#da3740',
  red7: '#aa2b32',
  red8: '#842127',
  red9: '#65191d',
  red10: '#5b1418',
} as const;

// Colors / Base / Orange
const baseOrange = {
  orange1: '#fcf0e7',
  orange2: '#f7d2b6',
  orange3: '#f3bc92',
  orange4: '#ea8a42',
  orange5: '#e56d13',
  orange6: '#d06311',
  orange7: '#a34d0d',
  orange8: '#7e3c0a',
  orange9: '#602e08',
} as const;

// Colors / Base / Blue
const baseBlue = {
  blue1: '#e9f4fd',
  blue2: '#bbdbf9',
  blue3: '#9acaf6',
  blue4: '#4fa3ef',
  blue5: '#238ceb',
  blue6: '#207fd6',
  blue7: '#1963a7',
  blue8: '#134d81',
  blue9: '#0f3b63',
} as const;

// Colors / Base / Geekblue
const baseGeekblue = {
  geekblue1: '#ededff',
  geekblue2: '#c7c7ff',
  geekblue3: '#acacff',
  geekblue4: '#6f6fff',
  geekblue5: '#4b4bff',
  geekblue6: '#4444e8',
  geekblue7: '#3535b5',
  geekblue8: '#29298c',
  geekblue9: '#20206b',
  geekblue10: '#0e0e4b',
} as const;

// Colors / Base / Gold
const baseGold = {
  gold1: '#fffbe9',
  gold2: '#fff1b9',
  gold3: '#ffea98',
  gold4: '#ffdb4b',
  gold5: '#ffd21e',
  gold6: '#e8bf1b',
  gold7: '#b59515',
  gold8: '#8c7411',
  gold9: '#6b580d',
  gold10: '#4f4004',
} as const;

// Colors / Base / Magenta
const baseMagenta = {
  magenta1: '#fbedfa',
  magenta2: '#f1c6f0',
  magenta3: '#eaaae8',
  magenta4: '#db6bd7',
  magenta5: '#d246cd',
  magenta6: '#bf40bb',
  magenta7: '#953292',
  magenta8: '#742771',
  magenta9: '#581d56',
  magenta10: '#250724',
} as const;

// Colors / Base / Purple
const basePurple = {
  purple1: '#f6edfd',
  purple2: '#e2c6fa',
  purple3: '#d4abf8',
  purple4: '#b46df2',
  purple5: '#a148ef',
  purple6: '#9342d9',
  purple7: '#7233aa',
  purple8: '#592883',
  purple9: '#441e64',
  purple10: '#270b3f',
} as const;

// Colors / Base / Yellow
const baseYellow = {
  yellow1: '#feffe6',
  yellow2: '#ffffb8',
  yellow3: '#fffb8f',
  yellow4: '#fff566',
  yellow5: '#ffec3d',
  yellow6: '#fadb14',
  yellow7: '#d4b106',
  yellow8: '#ad8b00',
  yellow9: '#876800',
  yellow10: '#614700',
} as const;

// Colors / Neutral
const neutral = {
  colorWhite: '#ffffff',
  colorBgBase: '#ffffff',
  colorTextBase: '#131110',
  transparent: '#0000',
} as const;

// Colors / Neutral / Text
const neutralText_p1 = {
  colorText: '#2D2926',
  colorTextSecondary: baseSmartGrey.smartGrey7,
  colorTextTertiary: baseSmartGrey.smartGrey4,
  colorTextQuaternary: 'rgba(0,0,0,0.25)',
  colorTextLightSolid: '#ffffff',
} as const;
const neutralText_p2 = {
  colorTextHeading: neutralText_p1.colorText,
  colorTextLabel: neutralText_p1.colorTextSecondary,
  colorTextDescription: neutralText_p1.colorTextTertiary,
  colorTextDisabled: neutralText_p1.colorTextTertiary,
  colorTextPlaceholder: neutralText_p1.colorTextTertiary,
  solidTextColor: '#fff',
} as const;
const neutralText = {
  ...neutralText_p1,
  ...neutralText_p2,
} as const;

// Colors / Neutral / Icon
const neutralIcon = {
  colorIcon: neutralText.colorText,
  colorIconActive: basePrimaryGreen.primaryGreen5,
  colorIconHover: neutralText.colorTextSecondary,
} as const;

// Colors / Neutral / Fill
const neutralFill = {
  colorFill: 'rgba(0, 0, 0, 0.15)',
  colorFillSecondary: 'rgba(0, 0, 0, 0.06)',
  colorFillTertiary: 'rgba(0, 0, 0, 0.04)',
  colorFillQuaternary: 'rgba(0, 0, 0, 0.02)',
  colorFillContent: 'rgba(0,0,0,0.06)', // neutralFill.colorFillSecondary
  colorFillContentHover: 'rgba(0,0,0,0.15)', // neutralFill.colorFill
  colorFillAlter: 'rgba(0,0,0,0.02)', // neutralFill.colorFillQuaternary
  colorFillAlterSolid: '#fafafa',
  colorFilledHandleBg: '#f0f0f0',
} as const;

// Colors / Neutral / Bg
const neutralBg = {
  colorBgContainer: neutral.colorBgBase,
  colorBgElevated: neutral.colorBgBase,
  colorBgLayout: '#F3F3F4',
  colorBgMask: 'rgba(0, 0, 0, 0.45)',
  colorBgSpotlight: 'rgba(0,0,0,0.85)',
  colorBgContainerDisabled: neutralFill.colorFillTertiary,
  colorBgTextActive: neutralFill.colorFill,
  colorBgTextHover: neutralFill.colorFillSecondary,
  colorBorderBg: neutral.colorBgBase, // neutralBg.colorBgContainer
  colorBgSolid: '#252525',
  colorBgSolidActive: 'rgba(0,0,0,0.95)',
  colorBgSolidHover: 'rgba(0,0,0,0.75)',
} as const;

// Colors / Neutral / Border
const neutralBorder = {
  colorBorder: '#E9E9E9',
  colorBorderSecondary: baseSmartGrey.smartGrey1,
  colorSplit: 'rgba(0,0,0,0.06)',
} as const;

// Colors / Brand / Primary
const brandPrimary = {
  colorPrimary: basePrimaryGreen.primaryGreen5,
  colorPrimaryBg: basePrimaryGreen.primaryGreen1,
  colorPrimaryBgHover: basePrimaryGreen.primaryGreen2,
  colorPrimaryBorder: basePrimaryGreen.primaryGreen3,
  colorPrimaryBorderHover: basePrimaryGreen.primaryGreen4,
  colorPrimaryHover: basePrimaryGreen.primaryGreen6,
  colorPrimaryActive: basePrimaryGreen.primaryGreen7,
  colorPrimaryTextHover: basePrimaryGreen.primaryGreen5,
  colorPrimaryText: basePrimaryGreen.primaryGreen6,
  colorPrimaryTextActive: basePrimaryGreen.primaryGreen7,
} as const;

// Colors / Brand / Success
// Updated per design spec: Mint bg, Green icon/text
const brandSuccess = {
  colorSuccess: baseGreen.green5,
  colorSuccessBg: baseSubtleMint.subtleMint2,
  colorSuccessBgHover: baseSubtleMint.subtleMint3,
  colorSuccessBorder: baseSubtleMint.subtleMint6,
  colorSuccessBorderHover: baseSubtleMint.subtleMint7,
  colorSuccessHover: baseGreen.green6,
  colorSuccessActive: baseGreen.green7,
  colorSuccessTextHover: baseGreen.green5,
  colorSuccessText: baseGreen.green7,
  colorSuccessTextActive: baseGreen.green7,
} as const;

// Colors / Brand / Warning
// Updated per design spec: Gold colors
const brandWarning = {
  colorWarning: baseGold.gold6,
  colorWarningBg: baseGold.gold1,
  colorWarningBgHover: baseGold.gold2,
  colorWarningBorder: baseGold.gold4,
  colorWarningBorderHover: baseGold.gold5,
  colorWarningHover: baseGold.gold7,
  colorWarningActive: baseGold.gold8,
  colorWarningTextHover: baseGold.gold6,
  colorWarningText: baseGold.gold9,
  colorWarningTextActive: baseGold.gold9,
  colorWarningOutline: '#FFD7051A', // #FFD705 · 10%
} as const;

// Colors / Brand / Info
// Updated per design spec: Ledger White bg/border/icon, Mauve Gray text
const brandInfo = {
  colorInfo: baseLedgerWhite.ledgerWhite7,
  colorInfoBg: baseLedgerWhite.ledgerWhite3,
  colorInfoBgHover: baseLedgerWhite.ledgerWhite4,
  colorInfoBorder: baseLedgerWhite.ledgerWhite6,
  colorInfoBorderHover: baseLedgerWhite.ledgerWhite7,
  colorInfoHover: baseLedgerWhite.ledgerWhite8,
  colorInfoActive: baseLedgerWhite.ledgerWhite9,
  colorInfoTextHover: baseMauveGrey.mauveGrey7,
  colorInfoText: baseMauveGrey.mauveGrey9,
  colorInfoTextActive: baseMauveGrey.mauveGrey9,
} as const;

// Colors / Brand / Error
// Updated per design spec: Red 1 bg, Red 3 border, Red 5 icon, Red 8 text
const brandError = {
  colorError: baseRed.red5,
  colorErrorBg: baseRed.red1,
  colorErrorBgHover: baseRed.red2,
  colorErrorBorder: baseRed.red3,
  colorErrorBorderHover: baseRed.red4,
  colorErrorHover: baseRed.red6,
  colorErrorActive: baseRed.red7,
  colorErrorTextHover: baseRed.red5,
  colorErrorText: baseRed.red8,
  colorErrorTextActive: baseRed.red9,
  colorErrorOutline: 'rgba(255, 38, 5, 0.06)',
} as const;

// Colors / Brand / Link
const brandLink = {
  colorLink: basePrimaryGreen.primaryGreen5,
  colorLinkHover: basePrimaryGreen.primaryGreen2,
  colorLinkActive: basePrimaryGreen.primaryGreen7,
} as const;

// Colors / Brand / Control
const brandControl = {
  controlItemBgActive: brandPrimary.colorPrimaryBg,
  controlItemBgActiveDisabled: neutralFill.colorFill,
  controlItemBgActiveHover: brandPrimary.colorPrimaryBorderHover,
  controlItemBgHover: neutralFill.colorFillTertiary,
  controlOutline: basePrimaryGreen.primaryGreen1,
  controlTmpOutline: neutralFill.colorFillQuaternary,
} as const;

// Color / Base / Chart
const baseChart = {
  chartColorPrimary: basePrimaryGreen.primaryGreen5,
  chartText: neutralText.colorText,
  chartColor1: baseSubtleMint.subtleMint6,
  chartColor2: baseSubtleMint.subtleMint8,
  chartColor3: baseLime.lime5,
  chartColor7: baseLedgerWhite.ledgerWhite7,
  chartColor6: basePrimaryGreen.primaryGreen4,
  chartColor5: basePrimaryGreen.primaryGreen2,
  chartColor4: baseLime.lime8,
  chartColor8: baseGold.gold6,
  chartColor9: baseGold.gold7,
  chartColor10: baseCyan.cyan8,
} as const;

export const baseColors = {
  ...basePrimaryGreen,
  ...baseLime,
  ...baseSmartGrey,
  ...basePaperWhite,
  ...baseLedgerWhite,
  ...baseSubtleMint,
  ...baseMauveGrey,
  ...baseCyan,
  ...baseGreen,
  ...baseRed,
  ...baseOrange,
  ...baseBlue,
  ...baseGeekblue,
  ...baseGold,
  ...baseMagenta,
  ...basePurple,
  ...baseYellow,
  ...baseChart,
} as const;

export const semanticColors = {
  ...neutral,
  ...neutralText,
  ...neutralIcon,
  ...neutralBg,
  ...neutralBorder,
  ...neutralFill,
  ...brandPrimary,
  ...brandSuccess,
  ...brandWarning,
  ...brandInfo,
  ...brandError,
  ...brandLink,
  ...brandControl,
} as const;

const FE_Extra = {
  colorWhite: '#fff',
  colorBlack: '#000',
} as const;

// Helper function to add dashed variants of color names
const getDashedVariants = (colorObj: Record<string, string>) => {
  const result = {};

  Object.entries(colorObj).forEach(([key, value]) => {
    const dashedKey = key
      .replace(/([a-z])([A-Z])/g, '$1-$2') // handle camelCase (if any)
      .replace(/(\D)(\d+)/, '$1-$2'); // insert dash before number
    (result as any)[dashedKey.toLowerCase()] = value as string;
  });

  return result as Record<string, string>;
};

// Export a combined object with both semantic and base colors
export const colors = {
  ...baseColors,
  ...getDashedVariants(baseColors),
  ...semanticColors,
  ...getDashedVariants(semanticColors),
  ...FE_Extra,
  ...getDashedVariants(FE_Extra),
} as const;

// Type for the colors object
export type Colors = typeof colors;

/* -------------------------------------------------
   Optional grouped palettes for Tailwind extensions
   -------------------------------------------------
   These keep tailwind.config.js clean and consistent.
*/
export const groups = {
  primary: {
    DEFAULT: semanticColors.colorPrimary,
    foreground: semanticColors.colorWhite,
    light: semanticColors.colorPrimaryBg,
    hover: semanticColors.colorPrimaryHover,
    active: semanticColors.colorPrimaryActive,
  },
  success: {
    DEFAULT: semanticColors.colorSuccess,
    foreground: semanticColors.colorWhite,
    light: semanticColors.colorSuccessBg,
    hover: semanticColors.colorSuccessHover,
    active: semanticColors.colorSuccessActive,
  },
  warning: {
    DEFAULT: semanticColors.colorWarning,
    foreground: semanticColors.colorText,
    light: semanticColors.colorWarningBg,
    hover: semanticColors.colorWarningHover,
    active: semanticColors.colorWarningActive,
  },
  info: {
    DEFAULT: semanticColors.colorInfo,
    foreground: semanticColors.colorInfoText,
    light: semanticColors.colorInfoBg,
    hover: semanticColors.colorInfoHover,
    active: semanticColors.colorInfoActive,
  },
  destructive: {
    DEFAULT: semanticColors.colorError,
    foreground: semanticColors.colorWhite,
    light: semanticColors.colorErrorBg,
    hover: semanticColors.colorErrorHover,
    active: semanticColors.colorErrorActive,
  },
} as const;
